<template>
  <div>
    <v-layout
      v-if="info && !loading"
      wrap
    >
      <v-flex
        :xs12="!isDesktop"
        :xs4="isDesktop"
        style="padding:10px"
      >
        <v-card
          style="padding: 20px;"
          :style="{ 
            color: config ? config.ColorContent : null,
            fontFamily: config ? config.FontContent : null,
          }"
        >
          <h3>Media diaria de desperdicio</h3>
          <br/>
          <h1 style="text-align:right;"> {{ averageDailyFoodWaste }}kg</h1>
        </v-card>
      </v-flex>
      <v-flex
        :xs12="!isDesktop"
        :xs4="isDesktop"
        style="padding:10px"
      >
        <v-card
          style="padding: 20px;"
          :style="{ 
            color: config ? config.ColorContent : null,
            fontFamily: config ? config.FontContent : null,
          }"
        >
          <h3>Comida desperdiciada por cubierto</h3>
          <br/>
          <h1 style="text-align:right;"> {{ foodWastePerCover}}kg</h1>
        </v-card>
      </v-flex>
      <v-flex
        :xs12="!isDesktop"
        :xs4="isDesktop"
        style="padding:10px"
      >
        <v-card
          style="padding: 20px;"
          :style="{ 
            color: config ? config.ColorContent : null,
            fontFamily: config ? config.FontContent : null,
          }"
        >
          <h3>Huella de carbono asociada al desperdicio</h3>
          <br/>
          <h1 style="text-align:right;"> {{carbonReduction}}kg</h1>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import apiDtouch from '@/services/apiDtouch'
import utils from '@/services/utils'
import constants from '@/constants'
export default {
  name:'Item60Effiwaste',
  props: {
    content: {
      type: Object,
      default: null,
    },
    locale: {
      type: String,
      default: null,
    },
    config: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    info: null,
    averageDailyFoodWaste: null,
    foodWastePerCover: null,
    carbonReduction: null
  }),
  computed: {
    ...mapState('app', ['dtouchWorkspace']),
    workspaceID () {
      return this.dtouchWorkspace ? this.dtouchWorkspace : utils.getWorkspace('dtouch')
    },
    isSimulation () {
      return constants.simulationsRutes  ? constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0 : true
    },
    isMobile () {
      return this.isSimulation ? true : utils.isMobile()
    },
    isDesktop () {
      return !this.isMobile
    },
    primaryColor () {
      return this.config ? this.config.BGColor : null
    },
    secundaryColor () {
      return this.config ? this.config.BGColorSecundary : null
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        this.loading = true
        this.info = await new Promise((resolve) => apiDtouch.getAll(`v1/public/workspaces/${this.workspaceID}/effiwaste-data`)
          .then(response => {
            resolve(response)
          })
          .finally(() => {
            resolve([])
          }))
        if (!this.info) return
        this.averageDailyFoodWaste = this.info.averageDailyFoodWaste && this.info.averageDailyFoodWaste.length > 0 ? this.info.averageDailyFoodWaste.shift() : null
        this.foodWastePerCover = this.info.foodWastePerCover && this.info.foodWastePerCover.length > 0 ? this.info.foodWastePerCover.shift() : null
        this.carbonReduction = this.info.carbonReduction
      } catch (error) {
        console.log(error)
      }
      this.loading = false
    },
  },
}
</script>
<style scoped>
.flex-parent {
  display: flex;
  padding: 0px;
}

.flex-child-allergens {
  flex: 1;
  padding-right: 10px;
  width:30px !important;
}

.flex-child {
  flex: 1;
  padding-right: 0;
  width:30px !important;
}
</style>







